import { useState } from 'react';
import apiService from '../../axios/apiService';

export const useBranchList = () => {
    const [data, setData] = useState(undefined);
    const getBranchList = async (params) => {
        // Fetch branch list
        const list = await apiService.branchList(params);
        list && setData(list); // update data state
        return list;
    }

    return {
        data,
        getBranchList,
    }
}